import { render, staticRenderFns } from "./NewsAdmin.vue?vue&type=template&id=eed54fe2&scoped=true"
import script from "./NewsAdmin.vue?vue&type=script&lang=js"
export * from "./NewsAdmin.vue?vue&type=script&lang=js"
import style0 from "./NewsAdmin.vue?vue&type=style&index=0&id=eed54fe2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eed54fe2",
  null
  
)

export default component.exports